export const POSTING = 'POSTING';

export const PENDING = 'PENDING';

//For Quick Tasks
export const PREPARING = 'PREPARING';

//For Inspected tasks
export const ASSIGNING_INSPECTOR = 'ASSIGNING_INSPECTOR';
export const WAITING_FOR_QUOTES = 'WAITING_FOR_QUOTES';
export const WAITING_QUOTE_ACCEPTANCE = 'WAITING_QUOTE_ACCEPTANCE';

export const REQUESTING_QUOTES = 'REQUESTING_QUOTES';
export const ADVANCE_PAYMENT = 'ADVANCE_PAYMENT';

export const WORKING = 'WORKING';
export const COMPLETED = 'COMPLETED';
export const PAID = 'PAID';

export const CANCEL_TASK_BY_CLIENT = 'CANCEL_TASK_BY_CLIENT';
export const REJECTED = 'REJECTED'
